import * as z from "zod";

export const getAiEmailPreviewSuggestions = {
  name: "getAiEmailPreviewSuggestions" as const,
  input: z.object({
    text: z.string(),
    tone: z.string().optional(),
    subjectLine: z.string().optional(),
  }),
  output: z.array(z.object({ text: z.string(), tone: z.string() })),
};
